export var ShareControlMode;
(function (ShareControlMode) {
    ShareControlMode[ShareControlMode["Share"] = 1] = "Share";
    ShareControlMode[ShareControlMode["CopyLink"] = 2] = "CopyLink";
    ShareControlMode[ShareControlMode["AtMention"] = 3] = "AtMention";
    ShareControlMode[ShareControlMode["LinkSettings"] = 4] = "LinkSettings";
    ShareControlMode[ShareControlMode["ManageAccess"] = 5] = "ManageAccess";
    ShareControlMode[ShareControlMode["Notify"] = 6] = "Notify";
    ShareControlMode[ShareControlMode["AddPeople"] = 7] = "AddPeople";
})(ShareControlMode || (ShareControlMode = {}));
export var ShareError;
(function (ShareError) {
    ShareError[ShareError["authFailure"] = 1] = "authFailure";
    ShareError[ShareError["serverFailure"] = 2] = "serverFailure";
    ShareError[ShareError["invalidItem"] = 3] = "invalidItem";
    ShareError[ShareError["invalidWebAbsoluteUrl"] = 4] = "invalidWebAbsoluteUrl";
    ShareError[ShareError["generic"] = 5] = "generic";
    ShareError[ShareError["objectNotSupported"] = 6] = "objectNotSupported";
    ShareError[ShareError["invalidEmail"] = 7] = "invalidEmail";
})(ShareError || (ShareError = {}));
export var ShareType;
(function (ShareType) {
    ShareType[ShareType["share"] = 0] = "share";
    ShareType[ShareType["copy"] = 1] = "copy";
    ShareType[ShareType["outlook"] = 2] = "outlook";
    ShareType[ShareType["nonOutlook"] = 3] = "nonOutlook";
    ShareType[ShareType["moreApps"] = 4] = "moreApps";
    ShareType[ShareType["teams"] = 5] = "teams";
})(ShareType || (ShareType = {}));
export var ShareErrorCategory;
(function (ShareErrorCategory) {
    ShareErrorCategory[ShareErrorCategory["getSharingInformation"] = 1] = "getSharingInformation";
    ShareErrorCategory[ShareErrorCategory["shareLink"] = 2] = "shareLink";
    ShareErrorCategory[ShareErrorCategory["shareObject"] = 3] = "shareObject";
})(ShareErrorCategory || (ShareErrorCategory = {}));
//# sourceMappingURL=share.js.map